<template>
  <div class="container flex flex-direction">
    <dv-loading v-if="loading" class="loading">Loading...</dv-loading>
    <div class="flex align-center justify-between top-box">
      <div class="flex-sub top-img-left"></div>
      <div class="top-name">{{ xiaoqu_name }}物业数据管理屏</div>
      <div class="flex-sub top-img-right">
        <div class="time-box">
          {{ year }}年{{ month }}月
          <el-date-picker
            style="position: absolute;top: 0;left: 0;width: 100%;opacity: 0;cursor: pointer;"
            @change="setMonth"
            v-model="time"
            type="month"
            placeholder="选择月">
          </el-date-picker>
        </div>
      </div>
    </div>
    <div class="flex align-start justify-between padding">
      <div class="left-info">
        <div class="left-user">
          <h3 class="flex align-center justify-between">
            <span><img src="../../../assets/img/title-icon.png"> 社区概览</span>
            <img src="../../../assets/img/jiantou.png">
          </h3>
          <div class="user-img">
            <img :src="xiaoqu_images" alt="">
          </div>
        </div>
        <div class="flex align-center justify-between flex-wrap margin-bottom-xs user-admin">
          <div><p>房屋<br>认证</p><h4><b>{{ zongHuShu }}</b><span>户</span></h4></div>
          <div><p>小区<br>面积</p><h4><b>{{ zongMianJi }}</b><span>m²</span></h4></div>
          <div><p>登记<br>人口</p><h4><b>{{ zongRenKou }}</b><span>人</span></h4></div>
          <div><p>管家<br>人数</p><h4><b>{{ guanJiaShu }}</b><span>人</span></h4></div>
        </div>

        <div class="left-fenxi" v-if="two">
          <h3 class="flex align-center justify-between">
            <span><img src="../../../assets/img/title-icon.png"> 综合业务分析</span>
            <b>得分:{{ two.totle }}分</b>
          </h3>
          <div id="fenxi" style="width: 400px;height: 300px;margin: 0 auto;"></div>
        </div>

      </div>

      <div class="right-info" v-if="one">
        <div class="right-num flex align-center justify-between flex-wrap margin-bottom-sm">
          <div>业主签约率： <b>{{ one.yiQianHeTongLv }}%</b></div>
          <div>物业收缴率： <b>{{ one.yiJiaoFeiLv }}%</b></div>
          <div class="active">本月新增签约数： <b>{{ one.benYueXinZengHeTongShu }}户</b></div>
          <div class="active">缴费数户： <b>{{ one.yiJiaoFeiShu }}户</b></div>
        </div>

        <div class="right-bar-box flex align-center justify-between">
          <div class="right-bar">
            <h3 class="flex align-center justify-between mode-title">
              <span><img src="../../../assets/img/title-icon.png"> 签约率</span>
            </h3>
            <div id="bar1" style="width: 580px;height: 270px;"></div>
            <div class="flex align-center justify-around sts-num">
              <div>平均签约率： <span>{{YGPJqianYueLv}}%</span></div>
              <div class="active">平均缴费率： <span>{{YGPJshouFeiLv}}%</span></div>
            </div>
          </div>
          <div class="right-bar">
            <h3 class="flex align-center justify-between mode-title">
              <span><img src="../../../assets/img/title-icon.png"> 报修/完成</span>
            </h3>
            <div id="bar2" style="width: 580px;height: 270px;"></div>
            <div class="flex align-center justify-around sts-num">
              <div>月度报修次数： <span>{{YueBaoXiuNumZong}}</span></div>
              <div class="active">人均维修次数: <span>{{XQPJbaoXiuNum}}</span></div>
            </div>
          </div>
        </div>

        <div class="right-other flex align-center justify-between">
          <div class="gj-list">
            <div class="gz-item flex align-center justify-between" v-for="item in YGfuZeQuYu" :key="item.admin_id">
              <div class="gz-name">{{ item.name }}</div>
              <div class="gz-list flex align-center flex-wrap">
                <span v-for="(items,j) in item.buildings" :key="j">{{ items }}</span>
              </div>
              </div>
          </div>
          <div class="bz-ts flex align-start justify-between">
            <div class="table-box">
              <div><p class="active">管家</p>
                <p>投诉</p></div>
              <ul>
                <li v-for="(item,index) in YGbiaoYangCommentSort" :key="index"><p class="active">{{ item.name }}</p>
                  <p>{{ item.touSuNum }}</p></li>
              </ul>
            </div>
            <div class="table-box">
              <div><p class="active">管家</p>
                <p>表扬</p></div>
              <ul>
                <li v-for="(item,index) in YGbiaoYangCommentSort" :key="index"><p class="active">{{ item.name }}</p>
                  <p>{{ item.biaoYangNum }}</p></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {XQtongJiOne, XQtongJiTwo} from "@/api/tongji";
import {zhDate} from "@/utils/utils";
import {upFeil} from "@/config";
import * as echarts from "echarts";

export default {
  name: "community",
  data() {
    return {
      loading: false,
      time: new Date(),
      xiaoqu_name: '',
      xiaoqu_images: '',
      zongHuShu: 0,
      zongMianJi: 0,
      zongRenKou: 0,
      guanJiaShu: 0,
      one: null,
      two: null,
      YGfuZeQuYu:[],
      YGbiaoYangCommentSort:[],
      YGqianYueShouFeiLv:[],
      BXdata:[],
      YGPJqianYueLv : 0,
        YGPJshouFeiLv : 0,
          YueBaoXiuNumZong: 0,
      XQPJbaoXiuNum : 0,
    }
  },
  created() {
    this.year = zhDate(new Date(), 4)
    this.month = zhDate(new Date(), 5)
    this.init()
  },
  components: {},
  methods: {
    setMonth(e) {
      this.time = e
      this.year = zhDate(new Date(e), 4)
      this.month = zhDate(new Date(e), 5)
      this.init()
    },
    async init() {
      this.loading = true
      let _data = await XQtongJiOne(this.$route.query.id, this.year, this.month)
      let _data2 = await XQtongJiTwo(this.$route.query.id, this.year, this.month)
      this.loading = false
      console.log(_data, _data2)
      this.xiaoqu_name = _data.data.xiaoqu_name
      this.xiaoqu_images = upFeil + '/' + _data.data.xiaoqu_images
      this.zongHuShu = _data.data.zongHuShu
      this.zongMianJi = _data.data.zongMianJi
      this.zongRenKou = _data.data.zongRenKou
      this.guanJiaShu = _data.data.guanJiaShu
      this.YGfuZeQuYu = _data.data.YGfuZeQuYu
      this.YGbiaoYangCommentSort = _data.data.YGbiaoYangCommentSort


      this.one = _data2.data.one
      this.two = _data2.data.two
      this.YGPJqianYueLv = _data2.data.YGPJqianYueLv
      this.YGPJshouFeiLv = _data2.data.YGPJshouFeiLv
      this.YueBaoXiuNumZong = _data2.data.YueBaoXiuNumZong
      this.XQPJbaoXiuNum = _data2.data.XQPJbaoXiuNum
      this.YGqianYueShouFeiLv = _data2.data.YGqianYueShouFeiLv
      this.BXdata = _data2.data.BXdata
      this.$nextTick(() => {
        this.drawRadar()
        this.drawBar1()
        this.drawBar2()
      })
    },
    drawRadar() {
      let myChart = echarts.init(document.getElementById('fenxi'))
      // 绘制图表
      myChart.setOption({
        animationDuration: 3000,
        animationEasing: 'cubicOut',
        tooltip: {},
        radar: {
          // shape: 'circle',
          indicator: [
            {name: '收费率', max: 100},
            {name: '表彰', max: 100},
            {name: '投诉', max: 100},
            {name: '签约率', max: 100},

          ]
        },

        series: [
          {
            type: 'radar',
            data: [
              {
                value: [this.two.yiJiaoFeiLv, this.two.biaoYangNum, this.two.touSuNum, this.two.yiQianHeTongLv],
                name: '综合业务分析'
              },
            ],
            color: '#ffa563',
            label: {
              show: true,
              formatter: function (params) {
                return params.value;
              }
            },
            areaStyle: {
              color: new echarts.graphic.RadialGradient(0.1, 0.6, 1, [
                {
                  color: 'rgba(255, 145, 124, 0.1)',
                  offset: 0
                },
                {
                  color: 'rgba(255, 145, 124, 0.9)',
                  offset: 1
                }
              ])
            }
          }
        ]
      })
    },
    drawBar1(){
      let xData = []
      let y1Data = []
      let y2Data = []
      this.YGqianYueShouFeiLv.map(item=>{
        xData.push(item.name)
        y1Data.push(item.YGyiQianHeTongLv )
        y2Data.push(item.YGyiJiaoFeiLv )
      })
      let myChart = echarts.init(document.getElementById('bar1'))
      // 绘制图表
      myChart.setOption({
        animationDuration: 3000,
        animationEasing: 'cubicOut',
        tooltip: {
          trigger: 'axis'
        },
        //图例组件
        legend: {
          data: ['签约率','缴费率'],
          textStyle: {fontSize: 14, color: '#fff5b3'}
        },
        toolbox: {
          show: true,
        },
        // 设置网格样式
        grid: {
          show: false,// 显示边框
          top: '12%',
          left: '3%',
          right: '3%',
          bottom: '3%',
          borderColor: '#fff',// 边框颜色
          containLabel: true // 包含刻度文字在内
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            // prettier-ignore
            data: xData,
            axisTick: {
              show: false//去除刻度线
            },
            axisLabel: {
              color: '#fff',//文本颜色
              // rotate:40
            },
            axisLine: {
              show: false//去除轴线
            },
            // boundaryGap: false//去除轴内间距
          }
        ],
        yAxis: {
          // 数据作为刻度文字
          type: 'value',
          axisTick: {
            show: false//去除刻度线
          },
          axisLabel: {
            color: '#fff'//文本颜色
          },
          axisLine: {
            show: false//去除轴线
          },
          boundaryGap: false//去除轴内间距
        },
        series: [
          {
            name: '签约率',
            type: 'bar',
            data: y1Data,
            color:'#ffa563'
          },
          {
            name: '缴费率',
            type: 'bar',
            data: y2Data,
            color:'#ff6969'
          }
        ]
      })

    },
    drawBar2(){
      let xData = []
      let y1Data = []
      let y2Data = []
      this.BXdata.map(item=>{
        xData.push(item.name)
        y1Data.push(item.BaoXiuNum )
        y2Data.push(item.WanChengNum )
      })
      let myChart = echarts.init(document.getElementById('bar2'))
      // 绘制图表
      myChart.setOption({
        animationDuration: 3000,
        animationEasing: 'cubicOut',
        tooltip: {
          trigger: 'axis'
        },
        //图例组件
        legend: {
          data: ['报修','完成'],
          textStyle: {fontSize: 14, color: '#fff5b3'}
        },
        toolbox: {
          show: true,
        },
        // 设置网格样式
        grid: {
          show: false,// 显示边框
          top: '12%',
          left: '3%',
          right: '3%',
          bottom: '3%',
          borderColor: '#fff',// 边框颜色
          containLabel: true // 包含刻度文字在内
        },
        calculable: true,
        xAxis: [
          {
            type: 'category',
            // prettier-ignore
            data: xData,
            axisTick: {
              show: false//去除刻度线
            },
            axisLabel: {
              color: '#fff',//文本颜色
              // rotate:40
            },
            axisLine: {
              show: false//去除轴线
            },
            // boundaryGap: false//去除轴内间距
          }
        ],
        yAxis: {
          // 数据作为刻度文字
          type: 'value',
          axisTick: {
            show: false//去除刻度线
          },
          axisLabel: {
            color: '#fff'//文本颜色
          },
          axisLine: {
            show: false//去除轴线
          },
          boundaryGap: false//去除轴内间距
        },
        series: [
          {
            name: '报修',
            type: 'bar',
            data: y1Data,
            color:'#ffa563',
            barWidth: 20
          },
          {
            name: '完成',
            type: 'bar',
            data: y2Data,
            color:'#ff6969',
            barWidth: 20
          }
        ]
      })
    },
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.container {
  background: url(../../../assets/img/bg_data.jpg) no-repeat top;
  background-size: 100% 100%;
  min-height: 100vh;
  min-width: 1900px;

  .loading {
    color: #ffffff;
    background: rgba(#000, .5);
    position: fixed;
    z-index: 99;
  }

  .top-box {
    height: 66px;

    .top-img-left {
      height: 66px;
      background: url("../../../assets/img/left-top.png") no-repeat top right;
    }

    .top-img-right {
      position: relative;
      height: 66px;
      background: url("../../../assets/img/right-top.png") no-repeat top left;

      .time-box {
        position: absolute;
        top: 20px;
        right: 20px;
        font-size: 24px;
        color: #ffdd99;
      }
    }

    .top-name {
      width: max-content;
      font-size: 40px;
      line-height: 66px;
      letter-spacing: 2px;
      padding: 0 30px;
      color: #ffffff;
      text-shadow: 0px 0px 7px rgba(52, 255, 204, 0.1);
      background: linear-gradient(-42deg,
        #ffd48a 0%,
        #fff5bb 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }

  .mode-title {
    height: 50px;
    color: #fff;
    font-size: 26px;
  }

  .left-info {
    width: 520px;

    .left-user {
      h3 {
        height: 50px;
        color: #fff;
        font-size: 26px;
      }
    }

    .user-img {
      display: block;
      width: 520px;
      height: 300px;
      margin: 30px auto;
      background-color: #bc2a30;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .user-admin {
      div {
        width: 250px;
        height: 77px;
        padding: 20px;
        border: solid 1px #cf464a;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        p {
          font-size: 18px;
          letter-spacing: 1px;
          color: #f9b09f;
          margin-right: 20px;
        }

        h4 {
          line-height: 150%;

          b {
            font-size: 24px;
            letter-spacing: 1px;
            color: #fff5b3;
          }

          span {
            font-size: 18px;
            color: #f9b09f;
          }
        }
      }
    }

    .left-fenxi {
      height: 370px;
      padding: 20px;
      border: solid 1px #cf464a;

      h3 {
        font-size: 26px;
        color: #ffffff;
        height: 50px;
        line-height: 150%;
      }
    }
  }

  .right-info {
    width: 1300px;

    .right-num {
      height: 140px;
      padding: 20px;
      border: solid 1px #cf464a;
      margin-top: 20px;

      div {
        width: 50%;
        text-align: center;
        color: #ffa563;
        font-size: 30px;

        &.active {
          color: #ff6969;
        }

        b {
          color: #fff;

          span {
            font-size: 18px;
          }
        }
      }
    }

    .right-bar-box{
      margin-bottom: 30px;
      .right-bar{
        width: 640px;
        height: 405px;
        padding: 20px;
        border: solid 1px #cf464a;
        .sts-num{
          font-size: 20px;
          color: #ffa563;
          height: 50px;
          div{
            &.active{
              color: #ff6969;
            }
            span{
              color: #fff5b3;
            }
          }
        }
      }
    }

    .right-other{
      .gj-list{
        width: 640px;
        height: 370px;
        padding: 20px;
        border: solid 1px #cf464a;
        overflow-y: auto;
        .gz-item{
          margin-bottom: 20px;
          min-height: 30px;
          .gz-name{
            display: flex;
            align-items: center;
            justify-content: space-around;
            width: 150px;
            font-size: 20px;
            letter-spacing: 1px;
            color: #fff5b3;
          }
          .gz-list{
            flex: 1;
            border-bottom: 1px solid #cf464a;
            min-height: 30px;
            span{
              display: block;
              padding: 3px 6px;
              font-size: 18px;
              letter-spacing: 1px;
              color: #fff5b3;
              border: 1px solid #fff5b3;
              margin: 0 10px 10px 0;
            }
          }
        }
      }
      .bz-ts{
        width: 640px;
        height: 370px;
        padding: 20px;
        border: solid 1px #cf464a;
        .table-box {
          width: 290px;

          div {
            display: flex;
            align-items: center;
            height: 50px;
            background-color: #a7292e;

            p {
              text-align: center;
              font-size: 18px;
              color: #ffffff;
              padding: 0 10px;
              width: 40%;
              line-height: 150%;

              &.active {
                width: 60%;
              }
            }
          }

          ul {
            height: 280px;
            overflow-y: auto;

            li {
              display: flex;
              align-items: center;
              background: #bc3235;
              min-height: 48px;
              border-bottom: 1px solid #e92f2f;

              p {
                text-align: center;
                font-size: 16px;
                color: #ffffff;
                padding: 5px;
                width: 40%;

                &.active {
                  width: 60%;
                }
              }
            }
          }

        }
      }
    }
  }
}
</style>
